import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

interface ConversationListSkeletonProps {
  itemCount?: number
  className?: string
}

export function ConversationListSkeleton({ itemCount = 4, className }: ConversationListSkeletonProps) {
  return (
    <div className={cn('flex h-full w-full flex-col gap-2 overflow-hidden p-4 pb-8 pt-2', className)}>
      {Array.from({ length: itemCount }).map((_, index) => (
        <div
          key={`conversation-skeleton-${index}`}
          className="rounded-lg border bg-card/30 p-6"
        >
          <div className="flex items-start justify-between gap-4">
            <div className="flex-1 space-y-2">
              <Skeleton className="h-4 w-48" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-3/4" />
            </div>
            <div className="flex w-28 flex-col items-end gap-2">
              <Skeleton className="h-8 w-24 rounded-md" />
              <div className="flex items-center gap-2">
                <Skeleton className="h-4 w-4 rounded-full" />
                <Skeleton className="h-3 w-20" />
              </div>
            </div>
          </div>
          <div className="mt-5 flex items-center gap-2">
            <Skeleton className="h-3 w-16" />
            <Skeleton className="h-3 w-28" />
          </div>
        </div>
      ))}
    </div>
  )
}
